import { colors } from '../constants/colors';
import { typography } from '../constants/typography';
import { LinkTheme } from '@zopauk/react-components/types/components/styles/Theme';

export const link: LinkTheme = {
  active: {
    color: colors.jlMoneyGreenDark,
  },
  hover: {
    color: colors.jlMoneyBlueNeon,
  },
  weight: typography.weights.regular,
  color: colors.jlMoneyGreenDark,
  disableTargetIcon: true,
};
